import { MainTemplate } from 'components/templates/MainTemplate/MainTemplate';

function Root() {
  return <MainTemplate />;
}

export default Root;
